import { createContext } from 'react';

export type SidebarContextValues = {
  sidebarWidth: number;
  isSidebarVisible: boolean;
  isSidebarOpenButtonVisible: boolean;
  /**
   * サイドバー利用可否の非同期判定が確定した「次のレンダー」で true になる。
   * 確定前のレイアウト（サイドバー非表示のフル幅）を基準にした計算や、
   * 確定時の幅切り替えに CSS transition が乗るのを防ぐために使う。
   */
  isSidebarSettled: boolean;
  toggleSidebar: () => void;
};

export const SidebarContext = createContext<SidebarContextValues | null>(null);
